module.exports = __webpack_public_path__ + "img/icon-add-orange.f20738d0.svg";